import { css } from "styled-components";

export default css`
    h1 {
        font-size: 32px;
        font-weight: 600;
        color: ${p => p.theme.c.active};
        font-variant: small-caps;
    }

    h2 {
        font-size: 26px;
        font-weight: 600;
        color: ${p => p.theme.c.active};
    }

    h3 {
        font-size: 22px;
        font-weight: 600;
        color: inherit;
        font-variant: small-caps;
    }

    h4 {
        font-size: 20px;
        font-weight: 300;
        color: inherit;
    }
`;
